export enum ELkType {
  /** Собственник **/
  Homeowner = 'homeowner',
  /** Поискун **/
  Searcher = 'searcher',
  /** Специалист **/
  Specialist = 'specialist',
}
